(() => {
  if (window.dySplitScrollLoaded) return;
  window.dySplitScrollLoaded = true;
  const mobile = matchMedia('(max-width: 749px)');
  const homes = new WeakMap();
  function update() {
    document.querySelectorAll('[data-testid="product-information"] [data-product-grid-content]').forEach(grid => {
      const left = grid.querySelector(':scope > .product-information__media');
      const right = grid.querySelector(':scope > .product-details');
      if (!left || !right) return;
      grid.classList.remove('dy-split-scroll');
      grid.classList.add('dy-natural-product');
      grid.style.removeProperty('--dy-panel-height');
      grid.closest('.shopify-section')?.querySelector('sticky-add-to-cart')?.classList.remove('dy-split-dock');
      const detail = grid.querySelector('.dy-category-detail');
      if (!detail) return;
      if (!homes.has(detail)) {
        const marker = document.createComment('Product detail gallery position');
        detail.before(marker);
        homes.set(detail, marker);
      }
      if (mobile.matches) {
        if (detail.parentElement !== grid) right.after(detail);
      } else {
        const marker = homes.get(detail);
        if (marker.isConnected && detail.previousSibling !== marker) marker.after(detail);
      }
    });
  }
  mobile.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
  update();
})();
